import { render } from "./AddTransaction.vue?vue&type=template&id=5c68a4ba&scoped=true"
import script from "./AddTransaction.vue?vue&type=script&lang=js"
export * from "./AddTransaction.vue?vue&type=script&lang=js"

import "./AddTransaction.vue?vue&type=style&index=0&id=5c68a4ba&scoped=true&lang=css"

import exportComponent from "/Users/fikri/Work/PRiADI/code/priadi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c68a4ba"]])

export default __exports__